export type ColorScheme =
  | "goldenHour"
  | "hazySundown"
  | "fierceSundown"
  | "sunrise"
  | "midMorning"
  | "afterNoon";

export const moduleNameToSchemaMap = new Map([
  ["Nutrition", "goldenHour"],
  ["Mindset", "hazySundown"],
  ["Activity", "fierceSundown"],
  ["Long-Term Success", "afterNoon"],
  ["The Foundations", "sunrise"],
  ["Building Healthy Habits", "midMorning"]
]);
